module.exports = __webpack_public_path__ + "img/1540098457.6f461cba.jpg";